<template>
	<div class="footer">
	         <div class="main-footer">
			 	   <div class="main-1">
				   		 <img src="../../assets/img/logo-ft.png" width=135 height=25>
						 <ul class="box-list-footer">
						       <li class="cursor" @click="goPage('/board/notice')">공지사항</li>
							   <li>ㅣ</li>
							   <li class="cursor"  @click="goPage('/board/question')">1:1문의</li>
							   <li>ㅣ</li>
							   <li class="cursor" @click="goPage('/page/about')">소개</li>
							   <li>ㅣ</li>
							   <li class="cursor" @click="goPage('/page/agree')">이용약관</li>
							   <li>ㅣ</li>
							   <li class="cursor" @click="goPage('/page/private')">개인정보 처리방침</li>
						 </ul>
				   </div>
				   <div class="main-2">
				   		 <ul class="box-footer-left">
						 	  <li>고객센터 : 02-522-4025(상담시간 : 평일 09:00 ~ 18:00 <span class="text-footer">ㅣ</span>점심 : 12:00 ~ 13:00)</li>
							  <li>서울시 서초구 서초중앙로18길31 용원빌딩 2층 215호<span class="text-1">ㅣ</span>사업자등록번호 : 859-81-01467<span class="text-1">ㅣ</span>대표 : 유요한</li>
							  <li>COPYRIGHT 2020 NOSTRA.AI ALL RIGHTS RESERVED</li>
						 </ul>
						 <ul class="box-footer-right">
						      <li><i class="fas fa-chevron-up"></i></li>
							  <li style="cursor:pointer" @click="top()">TOP</li>
						 </ul>
				   </div>
			 </div>
	   </div>
</template>

<script>
export default {
  name: 'FooterLayout',
  data () {
	return {
 }
  },
  created: function() {
  },
  methods: {
	  goPage(url) {
			this.$router.push({path:url});
	  },
	  top() {
		 scrollTo(0,0);
	  }
	  
  },
  mounted: function() {
	
  },

}
</script>

<style lang="scss" scoped>
.footer  {
		   
			width:100%;
			height:210px;
			background:#333333;
			padding:38px 0;
			font-family: 'Nanum Gothic', sans-serif;
			color:#fff;
			.cursor {
				cursor:pointer;
			}
			.main-footer        {
						width:1190px;
						margin:0 auto;
						.main-1          {
								  .box-list-footer       {
								  			display:flex;
											float:right;
											li                {
													 margin-left:5px;
													 font-size:12px;
											}
								  }
						        
						}
						.main-2          {
								  margin-top:15px;
								 .box-footer-left      {
								             float:left;
											 li            {
											 		font-size:12px;
													margin-top:3px;
													.text-footer       {
															margin:0 5px;
															display:inline-block;
													}
													.text-1             {
															margin:0 5px;
															display:inline-block;
													}
													&:last-child        {
															margin-top:20px;
															font-size:12px;
													}
											 }
								 }
								 .box-footer-right       {
								 		  float:right;
										  width:58px;
										  height:58px;
										  background:#191A1E;
										  text-align:center;
										  margin-top:30px;
										  li                {
										  			font-size:12px;
													&:first-child      {
															margin-top:5px;
													}
										  }
								 }
						}
			}
}
</style>